import React from 'react';
import { Card, CardContent, Typography, Box, Grid, useTheme } from '@mui/material';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import RedeemIcon from '@mui/icons-material/Redeem';

const AnalyticsItem = ({ title, icon, data, theme, type }) => {
  const isMembership = type === 'membership';
  const mainColor = isMembership ? theme.palette.info.main : theme.palette.warning.main;
  const lightColor = isMembership ? theme.palette.info.light : theme.palette.warning.light;

  if (!data) {
    return (
      <Card sx={{ p: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 3, boxShadow: 3 }}>
        <Typography>No top {type} data for this month.</Typography>
      </Card>
    );
  }

  return (
    <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3, height: '100%', borderTop: `4px solid ${mainColor}` }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ backgroundColor: lightColor, borderRadius: '50%', p: 1, display: 'inline-flex', mr: 1.5 }}>
            {icon}
          </Box>
          <Typography variant="h6" fontWeight="600">{title}</Typography>
        </Box>
        <Typography variant="h5" fontWeight="bold" noWrap color={mainColor} sx={{ my: 1.5 }}>
          {data.membershipName || data.packageName}
        </Typography>
        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Grid item xs={6}>
             <Typography variant="caption" color="text.secondary">Usage Count</Typography>
            <Typography fontWeight="600">{data.usageCount}</Typography>

          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Total Amount</Typography>
            <Typography fontWeight="600">₹{data.totalAmount.toLocaleString('en-IN')}</Typography>

          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary" display="block">Contribution</Typography>
            <Typography variant="body2" fontWeight="600" color="success.main">{data.percentageContribution.toFixed(2)}%</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const TopMembershipPackageAnalytics = ({ analytics }) => {
  const theme = useTheme();

  if (!analytics) {
    return (
      <Grid container spacing={1.5}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 3, boxShadow: 3 }}>
            <Typography>No analytics data for this month.</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 3, boxShadow: 3 }}>
            <Typography>No analytics data for this month.</Typography>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12} md={6}>
        <AnalyticsItem title="Top Membership" icon={<CardMembershipIcon color="info" />} data={analytics.membership} theme={theme} type="membership" />
      </Grid>
      <Grid item xs={12} md={6}>
        <AnalyticsItem title="Top Package" icon={<RedeemIcon color="warning" />} data={analytics.package} theme={theme} type="package" />
      </Grid>
    </Grid>
  );
};

export default TopMembershipPackageAnalytics;